import { render, staticRenderFns } from "./SortProducts.vue?vue&type=template&id=3da29051&scoped=true&"
import script from "./SortProducts.vue?vue&type=script&lang=js&"
export * from "./SortProducts.vue?vue&type=script&lang=js&"
import style0 from "./SortProducts.vue?vue&type=style&index=0&id=3da29051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da29051",
  null
  
)

export default component.exports